<template>
  <footer class="app-footer py-2">
    <b-container fluid class="d-flex justify-content-between align-items-center px-4">
      <small><i class="fas fa-leaf mr-1"></i>© {{ new Date().getFullYear() }} Zerticarbon. All rights reserved.</small>
      <small v-if="appVersion" class="version-badge">v{{ appVersion }}</small>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION || ''
    }
  }
}
</script>

<style scoped>
.app-footer {
  position: relative;
  z-index: 1;
  background-color: var(--bg-secondary);
  border-top: 1px solid var(--border-subtle);
  font-size: 0.8rem;
  color: var(--text-muted);
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}
.app-footer i {
  color: var(--accent-green);
}
.version-badge {
  background-color: rgba(var(--accent-green-rgb), 0.12);
  padding: 2px 10px;
  border-radius: 999px;
  color: var(--accent-green);
  font-family: 'Sora', monospace;
  font-weight: 600;
  font-size: 0.72rem;
}
</style>
